<template>
  <div class="full-container" :style="'--padding:' + padding + 'px'">
    <div v-if="$slots.header" class="header" ref="header">
      <slot name="header" />
    </div>
    <el-scrollbar>
      <slot />
    </el-scrollbar>
    <div v-if="$slots.footer" class="footer" ref="footer">
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    padding: { type: Number, default: 0 },
  }
};
</script>

<style lang="scss" scoped>
.full-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .header {
    padding-bottom: 16px;
    margin: var(--padding);
  }
  .footer {
    padding-top: 16px;
    margin: var(--padding);
  }
  :deep(.el-scrollbar__view) {
    padding: 0 var(--padding);
  }
}
</style>
